import { Cross } from "lucide-react";

const WORDS = [
  "Faith",
  "Excellence",
  "Protection",
  "Above the Rest",
  "Built to Last",
  "Serving with Integrity",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((word) => (
      <span key={word} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl font-medium italic tracking-tight md:px-12 md:text-4xl">
          {word}
        </span>
        <Cross className="h-4 w-4 shrink-0 opacity-50" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-gold/25 bg-gold py-5 text-ink"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
